module.exports = __webpack_public_path__ + "static/media/webdesign-services-img29.43467cb1.jpg";